exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".abutton{font-weight:bold;color:#ddd;text-decoration:none}.abutton:hover{color:#82df8f;cursor:pointer}", ""]);

